import { NgIf } from '@angular/common';
import { Component, Inject, Input, input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [MatIconModule,NgIf],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent {

  constructor(public router:Router,public dialogRef: MatDialogRef<ConfirmationDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: {

    title?: string;
    message?: string;
    showClose?: boolean;
    showViewQuotes?: boolean;
    showNewQuote?: boolean;

  }){

  }
  onClose(): void {
    this.dialogRef.close('close');
  }

  onViewQuotes(): void {
    this.router.navigate(['/app/trips/requests']);
    this.dialogRef.close();
  }

  onNewQuote(): void {
    this.router.navigate(['/dashboard']);

    this.dialogRef.close();
  }

}
